@switch (config().buttonType) {
  @case ('mat-icon-button') {
    @if (config().link && config().navigationOption === 'routerLink') {
      <a
        mat-icon-button
        class="action-button"
        [matTooltip]="config().tooltipTranslationKey | translate"
        [routerLink]="config().link"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }
    @if (config().link && (!config().navigationOption || config().navigationOption === 'href')) {
      <a
        mat-icon-button
        class="action-button"
        [matTooltip]="config().tooltipTranslationKey | translate"
        [href]="config().link"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }
    @if (!config().link && config().handler) {
      <button
        mat-icon-button
        class="action-button"
        [matTooltip]="config().tooltipTranslationKey | translate"
        (click)="config().handler()"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
  }
  @case ('mat-raised-button') {
    @if (config().link && config().navigationOption === 'routerLink') {
      <a
        mat-raised-button
        color="primary"
        class="action-button"
        [matTooltip]="config().tooltipTranslationKey | translate"
        [routerLink]="config().link"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }
    @if (config().link && (!config().navigationOption || config().navigationOption === 'href')) {
      <a
        mat-raised-button
        color="primary"
        class="action-button"
        [matTooltip]="config().tooltipTranslationKey | translate"
        [href]="config().link"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }
    @if (!config().link && config().handler) {
      <button
        mat-raised-button
        color="primary"
        class="action-button"
        [matTooltip]="config().tooltipTranslationKey | translate"
        (click)="config().handler()"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
  }
  @case ('mat-button') {
    @if (config().link) {
      <a
        mat-button
        color="primary"
        class="action-button"
        [matTooltip]="config().tooltipTranslationKey | translate"
        [href]="config().link"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }
    @if (!config().link && config().handler) {
      <button
        mat-button
        color="primary"
        class="action-button"
        [matTooltip]="config().tooltipTranslationKey | translate"
        (click)="config().handler()"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }
  }
}

<ng-template #buttonContent>
  <div style="display: flex; place-content: center">
    @if (config().icon) {
      <mat-icon class="action-button-icon">
        {{ config().icon }}
      </mat-icon>
    }
    @if (config().labelTranslationKey) {
      <span>
        {{ config().labelTranslationKey | translate }}
      </span>
    }
  </div>
</ng-template>
